<template>
  <div class="forget-password">
    <a-steps :current="current">
      <a-step title="身份验证"></a-step>
      <a-step title="重置密码"></a-step>
      <a-step title="完成"></a-step>
    </a-steps>
    <div class="step-content">
      <a-form-model ref="formOne" :model="formOne" layout="vertical" :rules="rulesOne" v-if="current === 0">
        <a-form-model-item label="手机号" prop="phone">
          <a-input-search size="large" v-model="formOne.phone" placeholder="请输入手机号" @search="sendCode" allow-clear>
            <a-button slot="enterButton" disabled v-if="time">{{time}}s</a-button>
            <a-button slot="enterButton" v-else>发送验证码</a-button>
          </a-input-search>
        </a-form-model-item>
        <a-form-model-item label="验证码" prop="code">
          <a-input size="large" v-model="formOne.code" placeholder="请输入验证码" allow-clear></a-input>
        </a-form-model-item>
        <a-form-model-item>
          <a-button size="large" type="primary" block @click="nextStep">下一步</a-button>
        </a-form-model-item>
      </a-form-model>
      <a-form-model ref="formTwo" :model="formTwo" layout="vertical" :rules="rulesTwo" v-if="current === 1">
        <a-form-model-item label="新密码" prop="newPassword">
          <a-input size="large" v-model="formTwo.newPassword" placeholder="请输入新密码" allow-clear type="password"></a-input>
        </a-form-model-item>
        <a-form-model-item label="重复密码" prop="repeatPassword">
          <a-input size="large" v-model="formTwo.repeatPassword" placeholder="请输入重复密码" allow-clear type="password"></a-input>
        </a-form-model-item>
        <a-form-model-item>
          <a-button type="primary" size="large" block @click="submit">完成</a-button>
        </a-form-model-item>
      </a-form-model>
      <a-result status="success" title="新密码设置成功" sub-title="请牢记您设置的密码" v-if="current === 2">
        <template #extra>
          <a-button type="primary" size="large" block @click="showRegion('login')">完成</a-button>
        </template>
      </a-result>
      <a-row type="flex" justify="end">
        <a-button type="link" @click="showRegion('login')">返回登录</a-button>
      </a-row>
    </div>
  </div>
</template>

<script>
  import UserService from '@/io/user.js';

  export default {
    name: 'ForgetPassword',
    data() {
      return {
        current: 0,
        time: 0,
        formOne: {
          phone: null,
          code: null
        },
        rulesOne: {
          phone: [
            {
              required: true,
              message: '请填写手机号'
            }
          ],
          code: [
            {
              required: true,
              message: '请填写验证码'
            }
          ]
        },
        formTwo: {
          newPassword: null,
          repeatPassword: null
        },
        rulesTwo: {
          newPassword: [
            {
              required: true,
              message: '请填写新密码'
            }
          ],
          repeatPassword: [
            {
              required: true,
              message: '请填写重复密码'
            },
            {
              validator: this.$debounce((rule, value, callback) => {
                if (value && value !== this.formTwo.newPassword) {
                  callback(new Error('两次密码输入不一致'));
                } else {
                  callback();
                }
              })
            }
          ]
        }
      }
    },
    methods: {
      sendCode() {
        this.$refs.formOne.validateField(['phone'], err => {
          if (!err && !this.time) {
            UserService.forgetPasswordCode(this.formOne.phone).then(res => {
              this.initInterval();
            }).catch(err => {});
          }
        });
      },
      initInterval() {
        this.time = 60;
        let interval = setInterval(() => {
          if (this.time) {
            this.time--;
          } else {
            clearInterval(interval);
            interval = null;
          }
        }, 1000);
      },
      nextStep() {
        this.$beforeFormSubmit(this.$refs.formOne, () => {
          UserService.checkForgetPasswordCode(
            this.formOne.phone,
            this.formOne.code
          ).then(res => {
            this.current = 1;
          }).catch(err => {});
        });
      },
      submit() {
        this.$beforeFormSubmit(this.$refs.formTwo, () => {
          UserService.changePassword(
            this.formOne.phone,
            this.formOne.code,
            this.formTwo.newPassword,
            this.formTwo.repeatPassword
          ).then(res => {
            this.$afterFormSubmit('编辑成功', () => {
              this.current = 2;
            });
          }).catch(err => {});
        });
      },
      showRegion(name) {
        this.$emit('showRegion', name);
      }
    },
  }
</script>

<style lang="less" scoped>
  @import '../../assets/styles/tools.less';
  .forget-password {
    width: 30%;
    .step-content {
      margin: 40px;
    }
  }
</style>